import { Fragment } from "react";
import { Button } from "../../../../../components/ui";

const SectionHeader = props => {
  const { title, actions } = props;
  return (
    <>
      <div className="flex w-full flex-col gap-4 px-4 py-4 font-bold sm:px-6 lg:flex-row lg:items-center lg:px-8 lg:py-5">
        <div className="min-w-0 flex-1 text-2xl">{title}</div>
        <div className="flex flex-wrap gap-2 sm:gap-4">
          {actions?.map((item, key) => {
            return item?.component ? (
              <Fragment key={key}>{item?.component()}</Fragment>
            ) : (
              <Button
                action={item.type}
                key={key}
                className={item.className}
                label={item.label}
                onClick={item.action}
              />
            );
          })}
        </div>
      </div>
    </>
  );
};

export default SectionHeader;
